module.exports = __webpack_public_path__ + "img/team-h-avatar.6f120a78.png";